import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSetAtom } from 'jotai'
import { selectedAssetIdAtom } from '@app/state/propertyAtoms'
import { appLink } from '@app/config/appLink'
import { PropertySuggestion } from '../types'

export const useHandlePropertySearch = (selectedSuggestion?: PropertySuggestion | null) => {
  const setSelectedAssetId = useSetAtom(selectedAssetIdAtom)
  const navigate = useNavigate()

  return useCallback(
    (suggestion?: PropertySuggestion) => {
      const target = suggestion ?? selectedSuggestion
      if (target) {
        setSelectedAssetId(target.asset_id)
        navigate(`${appLink.property.path}/${target.asset_id}`)
      }
    },
    [selectedSuggestion, setSelectedAssetId, navigate],
  )
}
